export default "__VITE_ASSET__DDJb4cio__"